import type { ReactNode } from 'react'
import type { IconName } from '@/shared/ui/icon'
import { Icon } from '@/shared/ui/icon'
import s from './ScreenCard.module.css'

type ScreenCardProps = {
  icon: IconName
  /** Оттенок бейджа-иконки. По умолчанию нейтральный — не всякая служебная страница это ошибка. */
  tone?: 'neutral' | 'warning' | 'accent'
  title: string
  hint: string
  /** Нет действия — легитимное состояние: подсказки в `hint` бывает достаточно самой по себе. */
  action?: ReactNode
}

/**
 * Один шаблон полноэкранной служебной карточки — 404, «нет доступа», «нет компаний».
 * Та же карточка, что и у `DeathScreen` (widgets/death-screen), но без технической сводки:
 * эти страницы не про сбой, а про ожидаемое состояние навигации/доступа.
 */
export function ScreenCard({ icon, tone = 'neutral', title, hint, action }: ScreenCardProps) {
  return (
    <div className={s.root}>
      <div className={s.card}>
        <span className={s.badge} data-tone={tone}>
          <Icon name={icon} size={18} strokeWidth={1.9} />
        </span>

        <h1 className={s.title}>{title}</h1>
        <p className={s.hint}>{hint}</p>

        {action ? <div className={s.actions}>{action}</div> : null}
      </div>
    </div>
  )
}
